import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { ThemeProvider } from 'styled-components';
import { pcTheme, mobileTheme, FontsStyles, GlobalStyles } from '@styles';
import { useMatchMedia } from '@utils';
import { breakpoints } from '@config';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const ThemeSelector: React.FC = () => {
  const match = useMatchMedia(breakpoints.pc);
  
  return (
    <ThemeProvider theme={(match) ? pcTheme : mobileTheme}>
      <App />
      <FontsStyles />
      <GlobalStyles />
    </ThemeProvider>
  )
}

root.render(
  <ThemeSelector />
);
